import { AccountBlockedModal } from '@/features/modal/modals/AccountBlockedModal';
import BasicModal, { BasicModalProps } from './modals/BasicModal';
import { GeoLocationModal } from '@/features/modal/modals/geo-location/GeolocationModal';
import {
  BonusTermsAndConditionsModal,
  BonusTermsAndConditionsModalProps,
} from '@/features/modal/modals/BonusTermsAndConditionsModal';
import { CompleteProfileModal } from '@/features/modal/modals/CompleteProfileModal';
import { ConfirmModal, ConfirmModalProps } from '@/features/modal/modals/ConfirmModal';
import { ConsentsModal } from '@/features/modal/modals/ConsentsModal';
import { ContactInfoModal } from '@/features/modal/modals/ContactInfoModal';
import { ContactInfoModalSweden } from '@/features/modal/modals/ContactInfoModalSweden';
import { CookiesModal } from '@/features/modal/modals/CookiesModal';
import { StatsAndLimitsModal } from '@/features/modal/modals/StatsAndLimitsModal';
import {
  PayNPlayIframeModal,
  PayNPlayIframeModalProps,
} from '@/features/modal/modals/PayNPlayIframeModal';
import { UpdateStateModal } from '@/features/modal/modals/UpdateStateModal';
import { OntarioMigrationModal } from '@/features/modal/modals/OntarioMigrationModal';
import { AlbertaMigrationGateModal } from '@/features/modal/modals/AlbertaMigrationGateModal';
import { LocationGateModal } from '@/features/modal/modals/LocationGateModal';
import { AlbertaLoginMigrationModal } from '@/features/modal/modals/AlbertaLoginMigrationModal';
import { FitToPlayModal } from '@/features/modal/modals/FitToPlayModal';
import { DepositBalanceUpdateModal } from '@/features/modal/modals/DepositBalanceUpdateModal';
import { DetailsReverificationModal } from '@/features/modal/modals/DetailsReverificationModal';
import { ExitIntentModal } from '@/features/modal/modals/ExitIntentModal';
import { FailedLoginModal } from '@/features/modal/modals/FailedLoginModal';
import { FailedLoginSmsModal } from '@/features/modal/modals/FailedLoginSmsModal';
import { FixedDepositLimitErrorModal } from '@/features/modal/modals/FixedDepositLimitErrorModal';
import { IncompleteUserDataModal } from '@/features/modal/modals/IncompleteUserDataModal';
import { LineChatModal } from '@/features/modal/modals/LineChatModal';
import { LoginModal, LoginModalProps } from '@/features/modal/modals/login/LoginModal';
import { LoginSmsModal, LoginSmsModalProps } from '@/features/modal/modals/login-sms/LoginSmsModal';
import { OntarioCheckModal } from '@/features/modal/modals/OntarioCheckModal';
import { RequiredDepositLimitsModal } from '@/features/modal/modals/RequiredDepositLimitsModal';
import { RewardsWheelMarketingConsentModal } from '@/features/modal/modals/RewardsWheelMarketingConsentModal';
import { RewardsWheelDepositRequirementModal } from '@/features/modal/modals/RewardsWheelDepositRequirementModal';
import { RewardsWheelReminderModal } from '@/features/modal/modals/RewardsWheelReminderModal';
import { SmsMailReminderModal } from '@/features/modal/modals/SmsMailReminderModal';
import { SOWQModal } from '@/features/modal/modals/SOWQModal';
import { TermsAndConditionsModal } from '@/features/modal/modals/TermsAndConditionsModal';
import {
  WelcomeOffersModal,
  WelcomeOffersModalProps,
} from '@/features/modal/modals/WelcomeOffersModal';
import { Ref } from 'react';
import AvailableBonusesModal from '@/features/modal/modals/AvailableBonusesModal';
import RegisterManagerModal from '@/features/modal/modals/register/RegisterManagerModal';
import { TimeoutBlockModal } from '@/features/modal/modals/TimeoutBlockModal';
import { CheckinIdScanModal } from '@/features/modal/modals/checkin-id-scan/CheckinIdScanModal';
import { FreeToPlayExitModal } from '@/features/modal/modals/FreeToPlayExitModal';
import {
  BiometricOptInModal,
  BiometricOptInModalProps,
} from '@/features/modal/modals/BiometricOptInModal';

export enum MODALS {
  ACCOUNT_BLOCKED,
  BASIC,
  BIOMETRIC_OPT_IN,
  BONUS_TERMS_AND_CONDITIONS,
  COMPLETE_PROFILE,
  CONFIRM,
  CONSENTS,
  CONTACT_INFO,
  CONTACT_INFO_SWEDEN,
  COOKIES,
  DETAILS_REVERIFICATION,
  DEPOSIT_BALANCE_UPDATE,
  EXIT_INTENT,
  FAILED_LOGIN,
  FAILED_LOGIN_SMS,
  FIT_TO_PLAY,
  FIXED_DEPOSIT_LIMIT_ERROR,
  GEOLOCATION,
  INCOMPLETE_USER_DATA,
  LINE_CHAT,
  LOGIN,
  LOGIN_SMS,
  ONTARIO_CHECK,
  ONTARIO_MIGRATION,
  PAYNPLAY_IFRAME,
  REGISTER_MANAGER,
  REQUIRED_DEPOSIT_LIMITS,
  REWARDS_WHEEL_DEPOSIT_REQUIREMENT,
  REWARDS_WHEEL_MARKETING_CONSENT,
  REWARDS_WHEEL_REMINDER,
  SMS_MAIL_REMINDER,
  SOURCE_OF_WEALTH_QUESTIONNAIRE,
  STATE_UPDATE,
  STATS_AND_LIMITS,
  TERMS_AND_CONDITIONS,
  WELCOME_OFFERS,
  AVAILABLE_BONUSES,
  CHECKIN_ID_SCAN,
  TIMEOUT_BLOCK,
  FREE_TO_PLAY_EXIT_INTENT,
  ALBERTA_MIGRATION_GATE,
  LOCATION_GATE,
  ALBERTA_LOGIN_MIGRATION,
}

// The Modals order shown is reverse of the order in this array, meaning the last element in the array will be the first modal to be shown
export const MODALS_ORDER = [
  MODALS.CHECKIN_ID_SCAN,
  MODALS.TERMS_AND_CONDITIONS,
  MODALS.CONSENTS,
  MODALS.GEOLOCATION,
  MODALS.WELCOME_OFFERS,
  MODALS.ALBERTA_LOGIN_MIGRATION,
  MODALS.ALBERTA_MIGRATION_GATE,
  MODALS.LOCATION_GATE,
  MODALS.ONTARIO_CHECK,
  MODALS.TIMEOUT_BLOCK,
  MODALS.BIOMETRIC_OPT_IN,
];

export const MODAL_COMPONENTS = {
  [MODALS.ACCOUNT_BLOCKED]: AccountBlockedModal,
  [MODALS.BASIC]: BasicModal,
  [MODALS.BIOMETRIC_OPT_IN]: BiometricOptInModal,
  [MODALS.BONUS_TERMS_AND_CONDITIONS]: BonusTermsAndConditionsModal,
  [MODALS.COMPLETE_PROFILE]: CompleteProfileModal,
  [MODALS.CONFIRM]: ConfirmModal,
  [MODALS.CONSENTS]: ConsentsModal,
  [MODALS.CONTACT_INFO]: ContactInfoModal,
  [MODALS.CONTACT_INFO_SWEDEN]: ContactInfoModalSweden,
  [MODALS.COOKIES]: CookiesModal,
  [MODALS.DEPOSIT_BALANCE_UPDATE]: DepositBalanceUpdateModal,
  [MODALS.DETAILS_REVERIFICATION]: DetailsReverificationModal,
  [MODALS.EXIT_INTENT]: ExitIntentModal,
  [MODALS.FAILED_LOGIN]: FailedLoginModal,
  [MODALS.FAILED_LOGIN_SMS]: FailedLoginSmsModal,
  [MODALS.FIT_TO_PLAY]: FitToPlayModal,
  [MODALS.FIXED_DEPOSIT_LIMIT_ERROR]: FixedDepositLimitErrorModal,
  [MODALS.GEOLOCATION]: GeoLocationModal,
  [MODALS.INCOMPLETE_USER_DATA]: IncompleteUserDataModal,
  [MODALS.LINE_CHAT]: LineChatModal,
  [MODALS.LOGIN]: LoginModal,
  [MODALS.LOGIN_SMS]: LoginSmsModal,
  [MODALS.ONTARIO_CHECK]: OntarioCheckModal,
  [MODALS.ONTARIO_MIGRATION]: OntarioMigrationModal,
  [MODALS.PAYNPLAY_IFRAME]: PayNPlayIframeModal,
  [MODALS.REQUIRED_DEPOSIT_LIMITS]: RequiredDepositLimitsModal,
  [MODALS.REWARDS_WHEEL_DEPOSIT_REQUIREMENT]: RewardsWheelDepositRequirementModal,
  [MODALS.REWARDS_WHEEL_MARKETING_CONSENT]: RewardsWheelMarketingConsentModal,
  [MODALS.REWARDS_WHEEL_REMINDER]: RewardsWheelReminderModal,
  [MODALS.SMS_MAIL_REMINDER]: SmsMailReminderModal,
  [MODALS.SOURCE_OF_WEALTH_QUESTIONNAIRE]: SOWQModal,
  [MODALS.STATE_UPDATE]: UpdateStateModal,
  [MODALS.STATS_AND_LIMITS]: StatsAndLimitsModal,
  [MODALS.TERMS_AND_CONDITIONS]: TermsAndConditionsModal,
  [MODALS.WELCOME_OFFERS]: WelcomeOffersModal,
  [MODALS.AVAILABLE_BONUSES]: AvailableBonusesModal,
  [MODALS.REGISTER_MANAGER]: RegisterManagerModal,
  [MODALS.CHECKIN_ID_SCAN]: CheckinIdScanModal,
  [MODALS.TIMEOUT_BLOCK]: TimeoutBlockModal,
  [MODALS.FREE_TO_PLAY_EXIT_INTENT]: FreeToPlayExitModal,
  [MODALS.ALBERTA_MIGRATION_GATE]: AlbertaMigrationGateModal,
  [MODALS.LOCATION_GATE]: LocationGateModal,
  [MODALS.ALBERTA_LOGIN_MIGRATION]: AlbertaLoginMigrationModal,
};

export interface BaseModalProps {
  closeModal: (modal?: MODALS) => void;
  noBackdrop?: boolean;
  onBackdropClick?: () => void;
  noBackdropClick?: boolean;
  onClose?: () => void;
  modalWrapperRef?: Ref<HTMLDivElement>;
  hideOnClose?: boolean;
  pushHistory?: boolean;
}

interface BasicModalPropsExt extends BasicModalProps, Omit<BaseModalProps, 'closeModal'> {}

export interface BonusTermsAndConditionsModalPropsExt
  extends BonusTermsAndConditionsModalProps,
    Omit<BaseModalProps, 'closeModal'> {}

export interface ConfirmModalPropsExt
  extends ConfirmModalProps,
    Omit<BaseModalProps, 'closeModal'> {}

export interface PayNPlayIframeModalPropsExt
  extends PayNPlayIframeModalProps,
    Omit<BaseModalProps, 'closeModal'> {}

export interface LoginModalPropsExt extends LoginModalProps, Omit<BaseModalProps, 'closeModal'> {}

export interface LoginSmsModalPropsExt
  extends LoginSmsModalProps,
    Omit<BaseModalProps, 'closeModal'> {}

export interface WelcomeOffersModalPropsExt
  extends WelcomeOffersModalProps,
    Omit<BaseModalProps, 'closeModal'> {}

export interface BiometricOptInModalPropsExt
  extends BiometricOptInModalProps,
    Omit<BaseModalProps, 'closeModal'> {}

export type ModalProps =
  | Omit<BaseModalProps, 'closeModal'>
  | BasicModalPropsExt
  | BiometricOptInModalPropsExt
  | BonusTermsAndConditionsModalPropsExt
  | ConfirmModalPropsExt
  | PayNPlayIframeModalPropsExt
  | LoginModalPropsExt
  | LoginSmsModalPropsExt
  | WelcomeOffersModalPropsExt;

export interface Modal<T extends MODALS = MODALS> {
  name: T;
  props: ModalProps;
  component: (typeof MODAL_COMPONENTS)[T];
}

export interface ModalState {
  isOpen: boolean;
  modals: Modal[];
}

export interface ModalActions {
  openModal: <T extends MODALS>(modal: T, modalProps?: ModalProps) => void;
  closeModal: (modal?: MODALS) => void;
  resetModalsExcluded: (modals: MODALS[]) => void;
  resetModals: () => void;
}
